// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as InputField$OrcaPaymentPage from "./Components/InputField.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as FormViewTabs$OrcaPaymentPage from "./FormViewTabs.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as DropdownField$OrcaPaymentPage from "./Components/DropdownField.bs.js";
import * as CardValidations$OrcaPaymentPage from "../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as FormViewJourney$OrcaPaymentPage from "./FormViewJourney.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function CollectWidget(props) {
  let formLayout = props.formLayout;
  let handleSubmit = props.handleSubmit;
  let primaryTheme = props.primaryTheme;
  let availablePaymentMethodTypes = props.availablePaymentMethodTypes;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let constantString = match.constantString;
  let localeString = match.localeString;
  let config = match.config;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodCollectOptionAtom);
  let enabledPaymentMethodsWithDynamicFields = match$1.enabledPaymentMethodsWithDynamicFields;
  let setPayoutDynamicFields = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.payoutDynamicFieldsAtom);
  let match$2 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.formDataAtom);
  let setFormData = match$2[1];
  let formData = match$2[0];
  let activePmt = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodTypeAtom);
  let match$3 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.validityDictAtom);
  let setValidityDict = match$3[1];
  let validityDict = match$3[0];
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  let supportedCardBrands = React.useMemo(() => PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue), [paymentMethodListValue]);
  let match$4 = React.useState(() => PaymentMethodCollectUtils$OrcaPaymentPage.defaultView(formLayout));
  let setCurrentView = match$4[1];
  let currentView = match$4[0];
  React.useEffect(() => {
    setCurrentView(param => PaymentMethodCollectUtils$OrcaPaymentPage.defaultView(formLayout));
  }, [formLayout]);
  React.useEffect(() => {
    Core__Option.map(Core__Option.flatMap(PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutDynamicFields(enabledPaymentMethodsWithDynamicFields, activePmt), payoutDynamicFields => {
      setPayoutDynamicFields(param => payoutDynamicFields);
      return PaymentMethodCollectUtils$OrcaPaymentPage.getDefaultsAndValidity(payoutDynamicFields, supportedCardBrands);
    }), param => {
      let validity = param[1];
      let values = param[0];
      setFormData(param => values);
      setValidityDict(param => validity);
    });
  }, [activePmt]);
  let setFormData$1 = (key, value) => setFormData(prevDict => {
    let copy = Object.assign({}, prevDict);
    copy[key] = value;
    return copy;
  });
  let setValidityDictVal = (key, value) => setValidityDict(prevDict => {
    let copy = Object.assign({}, prevDict);
    copy[key] = value;
    return copy;
  });
  let inputRef = React.useRef(null);
  let cardNumberRef = React.useRef(null);
  let cardExpRef = React.useRef(null);
  let cardHolderRef = React.useRef(null);
  let routingNumberRef = React.useRef(null);
  let achAccNumberRef = React.useRef(null);
  let bacsSortCodeRef = React.useRef(null);
  let bacsAccNumberRef = React.useRef(null);
  let ibanRef = React.useRef(null);
  let sepaBicRef = React.useRef(null);
  let bankNameRef = React.useRef(null);
  let bankCityRef = React.useRef(null);
  let countryCodeRef = React.useRef(null);
  let renderDropdownTemplate = field => {
    if (field.TAG !== "BillingAddress") {
      return null;
    }
    let countries = field._0;
    if (typeof countries !== "object") {
      return null;
    }
    if (countries.TAG !== "AddressCountry") {
      return null;
    }
    let countries$1 = countries._0;
    let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey(field);
    let value = Core__Option.getOr(formData[key], "");
    if (countries$1.length > 0) {
      return JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(DropdownField$OrcaPaymentPage.make, {
          appearance: config.appearance,
          value: value,
          setValue: getVal => {
            let updatedValue = getVal();
            let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(updatedValue, Core__Option.getOr(supportedCardBrands, []));
            let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(updatedValue);
            let isValid = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity(field, updatedValue, newCardBrand, false);
            setValidityDictVal(key, isValid);
            if (Core__Option.getOr(isValid, false)) {
              return setFormData$1(key, updatedValue);
            }
          },
          fieldName: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel(field, localeString),
          options: DropdownField$OrcaPaymentPage.updateArrayOfStringToOptionsTypeArray(countries$1),
          disabled: false
        })
      }, key);
    } else {
      return null;
    }
  };
  let renderInputTemplate = field => {
    let inputRef$1;
    if (field.TAG === "BillingAddress") {
      inputRef$1 = inputRef;
    } else {
      let tmp = field._0;
      if (typeof tmp !== "object") {
        switch (tmp) {
          case "CardNumber" :
            inputRef$1 = cardNumberRef;
            break;
          case "CardHolderName" :
            inputRef$1 = cardHolderRef;
            break;
          case "ACHRoutingNumber" :
            inputRef$1 = routingNumberRef;
            break;
          case "ACHAccountNumber" :
            inputRef$1 = achAccNumberRef;
            break;
          case "BacsSortCode" :
            inputRef$1 = bacsSortCodeRef;
            break;
          case "BacsAccountNumber" :
            inputRef$1 = bacsAccNumberRef;
            break;
          case "SepaIban" :
            inputRef$1 = ibanRef;
            break;
          case "SepaBic" :
            inputRef$1 = sepaBicRef;
            break;
          case "ACHBankName" :
          case "BacsBankName" :
          case "SepaBankName" :
            inputRef$1 = bankNameRef;
            break;
          case "ACHBankCity" :
          case "BacsBankCity" :
          case "SepaBankCity" :
            inputRef$1 = bankCityRef;
            break;
          case "SepaCountryCode" :
            inputRef$1 = countryCodeRef;
            break;
          default:
            inputRef$1 = inputRef;
        }
      } else {
        inputRef$1 = cardExpRef;
      }
    }
    let pattern = Core__Option.getOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldCharacterPattern(field), /.*/).source;
    let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey(field);
    let value = Core__Option.getOr(formData[key], "");
    let isValid = Core__Option.flatMap(validityDict[key], key => key);
    let match = isValid !== undefined && !isValid ? [
        PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataErrorString(field, value, localeString),
        "text-xs text-red-950"
      ] : [
        "",
        ""
      ];
    return JsxRuntime.jsx(InputField$OrcaPaymentPage.make, {
      isValid: undefined,
      id: key,
      setIsValid: updatedValidityFn => setValidityDictVal(key, updatedValidityFn()),
      value: value,
      onChange: event => {
        let value = event.target.value;
        let inputType = event.target.type;
        let match;
        let exit = 0;
        let exit$1 = 0;
        let exit$2 = 0;
        if (value === "") {
          match = [
            true,
            ""
          ];
        } else if (field.TAG === "BillingAddress") {
          exit$2 = 3;
        } else {
          let tmp = field._0;
          if (typeof tmp !== "object") {
            if (tmp === "CardNumber") {
              let exit$3 = 0;
              switch (inputType) {
                case "number" :
                case "tel" :
                  exit$3 = 4;
                  break;
                default:
                  exit$2 = 3;
              }
              if (exit$3 === 4) {
                let cardType = CardUtils$OrcaPaymentPage.getCardType(Core__Option.getOr(formData[PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                      TAG: "PayoutMethodData",
                      _0: "CardBrand"
                    })], ""));
                let formattedCardNumber = CardUtils$OrcaPaymentPage.formatCardNumber(value, cardType);
                let clearCardNumber = CardValidations$OrcaPaymentPage.clearSpaces(formattedCardNumber);
                let cardTypeStr = CardUtils$OrcaPaymentPage.getCardStringFromType(cardType);
                if (CardUtils$OrcaPaymentPage.focusCardValid(clearCardNumber, cardTypeStr)) {
                  CardUtils$OrcaPaymentPage.handleInputFocus(cardNumberRef, cardExpRef);
                }
                if (CardUtils$OrcaPaymentPage.maxCardLength(cardTypeStr) === clearCardNumber.length) {
                  setValidityDictVal("card.cardNumber", PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity(field, value, cardTypeStr, Primitive_option.some(undefined)));
                } else {
                  setValidityDictVal("card.cardNumber", true);
                }
                match = [
                  true,
                  formattedCardNumber
                ];
              }
            } else {
              exit$2 = 3;
            }
          } else {
            let exit$4 = 0;
            switch (inputType) {
              case "number" :
              case "tel" :
                exit$4 = 4;
                break;
              default:
                exit$2 = 3;
            }
            if (exit$4 === 4) {
              let formattedExpiry = CardValidations$OrcaPaymentPage.formatCardExpiryNumber(value);
              let isCardExpiryValid = CardUtils$OrcaPaymentPage.isExipryValid(formattedExpiry);
              if (isCardExpiryValid) {
                CardUtils$OrcaPaymentPage.handleInputFocus(cardExpRef, cardHolderRef);
              }
              if (formattedExpiry.length === PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldMaxLength(field)) {
                setValidityDictVal("card.cardExp", isCardExpiryValid);
              } else {
                setValidityDictVal("card.cardExp", true);
              }
              match = [
                true,
                formattedExpiry
              ];
            }
          }
        }
        if (exit$2 === 3) {
          let exit$5 = 0;
          switch (inputType) {
            case "number" :
            case "tel" :
              exit$5 = 4;
              break;
            default:
              if (field.TAG === "BillingAddress") {
                exit = 1;
              } else {
                let tmp$1 = field._0;
                if (typeof tmp$1 !== "object") {
                  switch (tmp$1) {
                    case "SepaIban" :
                    case "SepaBic" :
                      exit$1 = 2;
                      break;
                    default:
                      exit = 1;
                  }
                } else {
                  exit = 1;
                }
              }
          }
          if (exit$5 === 4) {
            try {
              let bigIntValue = BigInt(value);
              match = [
                true,
                bigIntValue.toString()
              ];
            } catch (exn) {
              match = [
                false,
                value
              ];
            }
          }
        }
        if (exit$1 === 2) {
          if (inputType === "text") {
            match = [
              true,
              value.toUpperCase()
            ];
          } else {
            exit = 1;
          }
        }
        if (exit === 1) {
          match = Core__Option.mapOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldCharacterPattern(field), [
            true,
            value
          ], regex => {
            if (regex.test(value)) {
              return [
                true,
                value
              ];
            } else {
              return [
                false,
                value
              ];
            }
          });
        }
        if (!match[0]) {
          return;
        }
        let updatedValue = match[1];
        if (field.TAG !== "BillingAddress") {
          let tmp$2 = field._0;
          if (typeof tmp$2 !== "object" && tmp$2 === "CardNumber") {
            let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(updatedValue, Core__Option.getOr(supportedCardBrands, []));
            let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(updatedValue);
            setFormData$1(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
              TAG: "PayoutMethodData",
              _0: "CardBrand"
            }), newCardBrand);
          }
        }
        setFormData$1(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey(field), updatedValue);
      },
      onBlur: ev => {
        let value = ev.target.value;
        let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
        let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
        let isValid = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity(field, value, newCardBrand, Primitive_option.some(undefined));
        setValidityDictVal(key, isValid);
      },
      errorString: match[0],
      errorStringClasses: match[1],
      fieldName: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel(field, localeString),
      type_: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldInputType(field),
      maxLength: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldMaxLength(field),
      pattern: pattern,
      placeholder: PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldPlaceholder(field, localeString, constantString),
      className: "min-w-full border mt-1.5 px-2.5 py-2 rounded-md border-jp-gray-200",
      inputRef: inputRef$1,
      isFocus: true,
      labelClassName: "text-sm mt-2.5 text-jp-gray-800",
      paymentType: "PaymentMethodCollectElement"
    });
  };
  let renderAddressForm = addressFields => addressFields.map((field, index) => {
    let match = field.fieldType;
    let match$1 = field.value;
    let tmp;
    if (typeof match !== "object") {
      switch (match) {
        case "Email" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "Email"
            });
          break;
        case "CountryCode" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "CountryCode"
            });
          break;
        case "PhoneNumber" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "PhoneNumber"
            });
          break;
        case "PhoneCountryCode" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "PhoneCountryCode"
            });
          break;
        case "AddressLine1" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "AddressLine1"
            });
          break;
        case "AddressLine2" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "AddressLine2"
            });
          break;
        case "AddressCity" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "AddressCity"
            });
          break;
        case "AddressState" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "AddressState"
            });
          break;
        case "AddressPincode" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "BillingAddress",
              _0: "AddressPincode"
            });
          break;
      }
    } else {
      tmp = match.TAG === "FullName" ? (
          match._0 === "FirstName" && match$1 === undefined ? renderInputTemplate({
              TAG: "BillingAddress",
              _0: {
                TAG: "FullName",
                _0: "FirstName"
              }
            }) : null
        ) : (
          match$1 !== undefined ? null : renderDropdownTemplate({
              TAG: "BillingAddress",
              _0: {
                TAG: "AddressCountry",
                _0: match._0
              }
            })
        );
    }
    return JsxRuntime.jsx(React.Fragment, {
      children: tmp
    }, index.toString());
  }).filter(ele => ele !== null);
  let renderPayoutMethodForm = payoutMethodFields => payoutMethodFields.map((payoutMethodField, index) => {
    let match = payoutMethodField.fieldType;
    let match$1 = payoutMethodField.value;
    let tmp;
    if (typeof match !== "object") {
      switch (match) {
        case "CardNumber" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "CardNumber"
          });
          break;
        case "CardHolderName" :
          tmp = match$1 !== undefined ? null : renderInputTemplate({
              TAG: "PayoutMethodData",
              _0: "CardHolderName"
            });
          break;
        case "ACHRoutingNumber" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "ACHRoutingNumber"
          });
          break;
        case "ACHAccountNumber" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "ACHAccountNumber"
          });
          break;
        case "BacsSortCode" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "BacsSortCode"
          });
          break;
        case "BacsAccountNumber" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "BacsAccountNumber"
          });
          break;
        case "SepaIban" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "SepaIban"
          });
          break;
        case "SepaBic" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "SepaBic"
          });
          break;
        case "PaypalMail" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "PaypalMail"
          });
          break;
        case "PaypalMobNumber" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "PaypalMobNumber"
          });
          break;
        case "PixKey" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "PixKey"
          });
          break;
        case "VenmoMobNumber" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "VenmoMobNumber"
          });
          break;
        case "InteracEmail" :
          tmp = renderInputTemplate({
            TAG: "PayoutMethodData",
            _0: "InteracEmail"
          });
          break;
        default:
          tmp = null;
      }
    } else {
      tmp = match._0 === "CardExpMonth" ? renderInputTemplate({
          TAG: "PayoutMethodData",
          _0: {
            TAG: "CardExpDate",
            _0: "CardExpMonth"
          }
        }) : null;
    }
    return JsxRuntime.jsx(React.Fragment, {
      children: tmp
    }, index.toString());
  }).filter(ele => ele !== null);
  let tmp;
  tmp = currentView.TAG === "Journey" ? JsxRuntime.jsx(FormViewJourney$OrcaPaymentPage.make, {
      availablePaymentMethods: props.availablePaymentMethods,
      availablePaymentMethodTypes: availablePaymentMethodTypes,
      primaryTheme: primaryTheme,
      handleSubmit: handleSubmit,
      enabledPaymentMethodsWithDynamicFields: enabledPaymentMethodsWithDynamicFields,
      journeyView: currentView._0,
      renderAddressForm: renderAddressForm,
      renderPayoutMethodForm: renderPayoutMethodForm
    }) : JsxRuntime.jsx(FormViewTabs$OrcaPaymentPage.make, {
      availablePaymentMethodTypes: availablePaymentMethodTypes,
      primaryTheme: primaryTheme,
      handleSubmit: handleSubmit,
      tabsView: currentView._0,
      renderAddressForm: renderAddressForm,
      renderPayoutMethodForm: renderPayoutMethodForm
    });
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex flex-col h-min p-6 items-center lg:rounded lg:shadow-lg lg:p-10 lg:min-w-[400px]"
  });
}

let make = CollectWidget;

let $$default = CollectWidget;

export {
  make,
  $$default as default,
}
/* jotai Not a pure module */
